{
  "customer.cases": "Kundens sager",
  "customer.information": "Kundens organisation",
  "customer.information.bylaws.pending": "Afventer",
  "customer.information.bylaws.title": "Vedtægter",
  "customer.information.company.companyType": "Virksomhedstype",
  "customer.information.company.customerNumber": "Kundenummer",
  "customer.information.company.cvrNumber": "CVR-nummer",
  "customer.information.company.economicActivity": "Økonomisk aktivitet",
  "customer.information.company.pending": "Afventer",
  "customer.information.company.statusCrm": "Status fra CRM",
  "customer.information.company.title": "Virksomhedsoplysninger",
  "customer.information.contact.address": "Adresse",
  "customer.information.contact.customer": "Kunde",
  "customer.information.contact.email": "$t(email)",
  "customer.information.contact.phone": "$t(phone)",
  "customer.information.contact.title": "Kontaktoplysninger",
  "customer.information.primaryContact.title": "Primær kontaktperson",
  "customer.loans": "Kundens aftaler",
  "customer.loansGuarantor": "Aftaler som garantistiller",
  "customer.loansInterest": "Aftaler som interessent",
  "customer.noCaseHistory": "Ingen sagshistorik tilgængelig",
  "customer.noLoansOfType": "Kunden har ingen {{ type }}",
  "customer.usersAndRoles": "Brugere og roller",
  "customer.usersAndRoles.title": "Brugere og rettigheder fra Signaturgruppen",
  "guarantor_one": "garantistiller",
  "guarantor_other": "garantistillere",
  "liability.guarantor.amount": "Garantibeløb",
  "liability.guarantor.name": "Garantistillernavn",
  "liability.guarantor.none": "Ingen garantistillere",
  "liability.guarantor.percentage": "Garantiprocent",
  "liability.interest.name": "Interessentnavn",
  "liability.interest.none": "Ingen interessenter",
  "stakeholder_one": "interessent",
  "stakeholder_other": "interessenter"
}
